// extracted by mini-css-extract-plugin
export default {"btn__default":"Button_btn__default__YY-99","btn__primary":"Button_btn__primary__K4mRd","btn__disable":"Button_btn__disable__AYJZ9"};